import { TApplicationState } from 'shared/types/redux';

export const fromDeveloperRoomsSelector = (state: TApplicationState) => {
  return state.newbuilding.stats.fromDeveloperRooms;
};
